import { Box, Stack, Typography } from '@mui/material';

import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { translate } from '@/ui/i18n';

export function WelcomeMessage({
  userName,
  welcomeText,
  onClickStartForm,
}: {
  userName: string;
  welcomeText?: string;
  onClickStartForm: () => void;
}) {
  return (
    <Box>
      <Stack spacing={4} alignItems={'start'}>
        <Typography sx={{ fontSize: '2.5rem', fontWeight: 900 }}>
          {translate('External.welcome-with-name', { name: userName })}
        </Typography>
        <Typography
          sx={{ fontSize: '1.25rem', fontWeight: 800, whiteSpace: 'pre-line' }}
        >
          {welcomeText || translate('External.welcome-description')}
        </Typography>
        <FSPrimaryButton onClick={onClickStartForm}>
          {translate('External.start-form')}
        </FSPrimaryButton>
      </Stack>
    </Box>
  );
}
